import { UserType } from '@quipex/shared/contracts';

type FourStarters = readonly [string, string, string, string];

export const PACK_TOPICS = {
    [UserType.Homeowner]: [
        'home maintenance',
        'renovation planning',
        'insurance review',
        'property handover',
    ],
    [UserType.PropertyValuer]: [
        'property valuation',
        'valuation inspection',
        'rental assessment',
        'valuation due diligence',
    ],
    [UserType.Architect]: [
        'design review',
        'alterations planning',
        'planning application',
        'design handover',
    ],
    [UserType.Lawyer]: [
        'legal due diligence',
        'contract review',
        'lease review',
        'statutory notice review',
    ],
    [UserType.Conveyancer]: [
        'conveyancing due diligence',
        'sale preparation',
        'settlement review',
        'title review',
    ],
    [UserType.Insurer]: [
        'insurance renewal',
        'risk inspection',
        'claims review',
        'underwriting review',
    ],
    [UserType.PropertyManager]: [
        'property management handover',
        'tenant onboarding',
        'lease renewal',
        'contractor briefing',
    ],
    [UserType.FacilitiesManager]: [
        'facilities handover',
        'maintenance contractor briefing',
        'compliance review',
        'equipment warranty review',
    ],
    [UserType.MaintenanceTechnician]: [
        'maintenance visit',
        'equipment repair',
        'preventive maintenance',
        'maintenance handover',
    ],
    [UserType.AssetManager]: [
        'asset condition review',
        'capital works planning',
        'asset handover',
        'asset replacement planning',
    ],
    [UserType.PortfolioManager]: [
        'portfolio reporting',
        'investment review',
        'capital allocation review',
        'property acquisition review',
    ],
    [UserType.RealEstateDeveloper]: [
        'development due diligence',
        'project feasibility',
        'development approval review',
        'development handover',
    ],
    [UserType.BuildingOwner]: [
        'building handover',
        'ownership due diligence',
        'insurance review',
        'maintenance planning',
    ],
    [UserType.LeasingManager]: [
        'leasing campaign',
        'tenant handover',
        'lease negotiation',
        'fit-out review',
    ],
    [UserType.OperationsManager]: [
        'operations handover',
        'service provider briefing',
        'incident review',
        'business continuity review',
    ],
    [UserType.ProjectManager]: [
        'project briefing',
        'project handover',
        'progress review',
        'project approval review',
    ],
    [UserType.ComplianceOfficer]: [
        'compliance audit',
        'occupancy approval review',
        'essential safety measures review',
        'regulatory inspection',
    ],
    [UserType.SafetyManager]: [
        'safety audit',
        'emergency planning',
        'incident investigation',
        'contractor safety briefing',
    ],
    [UserType.EnergyManager]: [
        'energy audit',
        'energy performance review',
        'metering review',
        'energy upgrade planning',
    ],
    [UserType.BuildingSuperintendent]: [
        'site handover',
        'service visit',
        'emergency response briefing',
        'building operations review',
    ],
    [UserType.RealEstateAnalyst]: [
        'investment analysis',
        'market assessment',
        'rental performance review',
        'property due diligence',
    ],
    [UserType.SustainabilityManager]: [
        'sustainability assessment',
        'environmental review',
        'waste management review',
        'building rating review',
    ],
    [UserType.ConstructionManager]: [
        'construction briefing',
        'site inspection',
        'construction handover',
        'quality assurance review',
    ],
    [UserType.BuildingAutomationSpecialist]: [
        'controls commissioning',
        'building automation handover',
        'controls fault investigation',
        'automation upgrade planning',
    ],
    [UserType.HvacTechnician]: [
        'HVAC service visit',
        'mechanical commissioning',
        'HVAC fault investigation',
        'HVAC equipment replacement',
    ],
    [UserType.Consultant]: [
        'consultant briefing',
        'technical assessment',
        'condition review',
        'advisory project handover',
    ],
    [UserType.Other]: [
        'building handover',
        'document review',
        'contractor briefing',
        'insurance review',
    ],
    [UserType.StrataManager]: [
        'owners corporation meeting',
        'strata management handover',
        'strata insurance renewal',
        'common property maintenance',
    ],
    [UserType.BuildingSurveyor]: [
        'building certification review',
        'occupancy inspection',
        'permit assessment',
        'building compliance inspection',
    ],
} as const satisfies Record<UserType, FourStarters>;
